import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Check, Trash2, Star } from "lucide-react";

export default function AdminReviews() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold tracking-tight mb-6">Yorumlar</h1>
      <div className="space-y-3">
        {list.map((r) => (
          <div key={r.id} className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="font-semibold">{r.name} <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${r.approved ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{r.approved ? "Yayında" : "Onay bekliyor"}</span></div>
                <div className="flex gap-1 my-1">{[...Array(r.rating)].map((_, i) => <Star key={i} size={12} className="fill-[#E9C46A] text-[#E9C46A]"/>)}</div>
                <p className="text-slate-700 text-sm">{r.comment}</p>
                <div className="text-xs text-slate-500 mt-1">{new Date(r.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex gap-2">
                {!r.approved && <button onClick={async () => { await api.put(`/admin/reviews/${r.id}/approve`); load(); }} className="text-emerald-700 p-2"><Check size={16}/></button>}
                <button onClick={async () => { if(window.confirm("Sil?")) { await api.delete(`/admin/reviews/${r.id}`); load(); }}} className="text-rose-600 p-2"><Trash2 size={16}/></button>
              </div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="bg-white rounded-2xl p-10 text-center text-slate-600">Yorum yok.</div>}
      </div>
    </div>
  );
}
